import type { FaireBrandEntity } from "@faire/playground-entity-db/entity_types/brand";
import type { FaireProductEntity } from "@faire/playground-entity-db/entity_types/product";

/** Stable placeholder used across search / grid prototypes when a shard has no image. */
export const DEFAULT_PLAYGROUND_PRODUCT_IMAGE =
  "https://cdn.prerelease.faire.dev/fastly/1666ef36b9499bd95f7080f86e21f06298ceb0ebc5e877c05a3d1426e9c7fc0f.webp";

/** Ensures a non-empty product image URL. Does not rewrite CDN hosts — many Fastly
 *  hashes exist only on `cdn.faire.com`; rewriting to prerelease breaks those loads. */
export const normalizeProductImageUrl = (url: string | undefined): string => {
  const trimmed = url?.trim() ?? "";
  if (!trimmed) {
    return DEFAULT_PLAYGROUND_PRODUCT_IMAGE;
  }
  return trimmed;
};

/** Trims optional media URLs; keeps empty as undefined (no forced placeholder). */
export const normalizeOptionalPlaygroundMediaUrl = (
  url: string | undefined
): string | undefined => {
  const trimmed = url?.trim() ?? "";
  if (!trimmed) {
    return undefined;
  }
  return trimmed;
};

export const withNormalizedProductMediaUrls = (
  product: FaireProductEntity
): FaireProductEntity => ({
  ...product,
  imageUrl: normalizeProductImageUrl(product.imageUrl),
  brandAvatarUrl: normalizeOptionalPlaygroundMediaUrl(product.brandAvatarUrl),
  afterImageUrl: normalizeOptionalPlaygroundMediaUrl(product.afterImageUrl),
  galleryImageUrls: product.galleryImageUrls?.map((u) =>
    normalizeProductImageUrl(u)
  ),
});

export const withNormalizedBrandMediaUrls = (
  brand: FaireBrandEntity
): FaireBrandEntity => ({
  ...brand,
  logoUrl: normalizeOptionalPlaygroundMediaUrl(brand.logoUrl),
  avatarUrl: normalizeOptionalPlaygroundMediaUrl(brand.avatarUrl),
  bannerUrl: normalizeOptionalPlaygroundMediaUrl(brand.bannerUrl),
  heroImageUrl: normalizeOptionalPlaygroundMediaUrl(brand.heroImageUrl),
});
